import React, { useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useAxiosGet } from '../Hooks/HttpRequests';
import MuiTable from '../Components/MuiTable';
import HeatMap from "react-heatmap-grid";
import RankMap from "../Components/HeatMap";
import { Overview, BarChart, LineChart, ApexHeatMap } from "../Components/ReactApexChart";
import { Grid, scopedCssBaselineClasses } from "@mui/material";



export default function League() {
    let baseUrl = "https://sleepercdn.com/avatars/thumbs/"
    let muff = "cb70ea50e6ad6c633cfb8596b0b441b2"
    let smd = "95c1a952fda0af6e2497de08832c868f"
    let miltown = "0475831b08aa97a5f85e2fc835dfcef2"

    const navigate = useNavigate();
    const location = useLocation();

    // Map tab values to slugs for URL routing
    const slugFromTab = {
        "1": 'lineup-averages',
        "2": 'compare-teams',
        "3": 'standings-by-week',
        "4": 'matchup-scores'
    };
    const tabFromSlug = Object.fromEntries(Object.entries(slugFromTab).map(([k, v]) => [v, k]));

    const segments = location.pathname.split('/').filter(Boolean);
    const slug = segments[1] || '';
    const value = tabFromSlug[slug] || "1";

    // Redirect bare /league to default tab route
    React.useEffect(() => {
        if (segments[0] === 'league' && !segments[1]) {
            navigate(`/league/${slugFromTab[value]}`, { replace: true });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const handleChange = (_event, newValue) => {
        const nextSlug = slugFromTab[newValue] || 'lineup-averages';
        if (nextSlug !== slug) navigate(`/league/${nextSlug}`);
    };

    // if (props.smd === 'yes') {
    //     return (
    //     <div className="p-3">
    //             <h1 className="font-bold text-2xl">SuperMegaDynasty</h1>
    //             <a href="https://sleeper.com/leagues/785959210730311680/league">
    //             <img src={`${baseUrl}${smd}`} id="smd" alt="League Icon" />
    //             </a>
    //         </div>
    //     )
    // }

    return (
        <div className="mb-3">
            {/* <h1 className="font-bold text-2xl">This is the Team page</h1> */}
            <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                textColor="primary"
            >
                <Tab value="1" label="Lineup Averages" />
                <Tab value="2" label="Compare Teams" />
                {/* <Tab value="3" label="Standings By Week" /> */}
                {/* <Tab value="4" label="Matchup Scores" /> */}
                {/* <Tab value="4" label="Four" /> */}
            </Tabs>
            <Divider />
            <div>
            {value === "1" && <LeagueAvg /> }
            {value === "2" && <CompareTree />}
            {value === "3" && <Three />}
            {/* {value === "4" && <MatchupScores />} */}
            {/* {value === "4" && <Four />}
            {value === "5" && <Five />} */}
            </div>
        </div>
        // <div>
        //     <div className="p-3 min-w-min">
        //         <h1 className="font-bold text-2xl">SuperMegaDynasty</h1>
        //         {/* <a href="https://sleeper.com/leagues/785959210730311680/league"> */}
        //         <img src={`${baseUrl}${smd}`} id="smd" alt="League Icon" />
        //         {/* </a> */}
        //     </div>
        //     <div className="p-3">
        //         <h1 className="font-bold text-2xl">Muff Bowl</h1>
        //         {/* <a href="https://sleeper.com/leagues/789178227129188352/league"> */}
        //         <img src={`${baseUrl}${muff}`} id="muff" alt="League Icon" />
        //         {/* </a> */}
        //     </div>
        //     <div className="p-3">
        //         <h1 className="font-bold text-2xl">Miltown</h1>
        //         {/* <a href="https://sleeper.com/leagues/789690710231203840/league"> */}
        //         <img src={`${baseUrl}${miltown}`} id="miltown" alt="League Icon" />
        //         {/* </a> */}
        //     </div>
        // </div>
    );
}

/* Moved to Home page (src/Components/MatchupScores.js) */
/* function MatchupScores() {
    const [week, setWeek] = useState(1);

    const leagueId = '1180948099673747456';
    const matchupUrl = `https://api.sleeper.app/v1/league/${leagueId}/matchups/${week}`;
    const rostersUrl = `https://api.sleeper.app/v1/league/${leagueId}/rosters`;
    const usersUrl = `https://api.sleeper.app/v1/league/${leagueId}/users`;

    const matchups = useAxiosGet(matchupUrl);
    const rosters = useAxiosGet(rostersUrl);
    const users = useAxiosGet(usersUrl);

    const nameByRosterId = useMemo(() => {
        const map = new Map();
        const rostersArr = Array.isArray(rosters.data) ? rosters.data : [];
        const usersArr = Array.isArray(users.data) ? users.data : [];
        const userById = new Map(usersArr.map(u => [String(u.user_id), u]));
        rostersArr.forEach(r => {
            const ownerId = r.owner_id != null ? String(r.owner_id) : null;
            const u = ownerId ? userById.get(ownerId) : null;
            const display = (r?.metadata?.team_name) || (u?.metadata?.team_name) || u?.display_name || `Roster ${r.roster_id}`;
            map.set(r.roster_id, display);
        });
        return map;
    }, [rosters.data, users.data]);

    const grouped = useMemo(() => {
        const rows = Array.isArray(matchups.data) ? matchups.data : [];
        const byMid = new Map();
        for (const m of rows) {
            const mid = m.matchup_id ?? `solo-${m.roster_id}`;
            if (!byMid.has(mid)) byMid.set(mid, []);
            byMid.get(mid).push(m);
        }
        const pairs = [];
        byMid.forEach((arr, key) => {
            const a = arr[0] || null;
            const b = arr[1] || null;
            pairs.push({ key, a, b });
        });
        // Sort by highest total points in matchup
        pairs.sort((p1, p2) => {
            const t1 = (p1.a?.points || 0) + (p1.b?.points || 0);
            const t2 = (p2.a?.points || 0) + (p2.b?.points || 0);
            return t2 - t1;
        });
        return pairs;
    }, [matchups.data]);

    return (
        <div className="p-3">
            <div className="mb-3 flex items-center gap-3">
                <h2 className="text-xl font-semibold">Matchup Scores</h2>
                <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel id="week-select-label">Week</InputLabel>
                    <Select
                        labelId="week-select-label"
                        id="week-select"
                        value={week}
                        label="Week"
                        onChange={(e) => setWeek(Number(e.target.value))}
                    >
                        {[...Array(18)].map((_, i) => (
                            <MenuItem key={i+1} value={i+1}>{i+1}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            {matchups.loading && (
                <div className="p-2">Loading matchups…</div>
            )}
            {matchups.error && (
                <div className="bg-red-100 text-red-700 p-2 rounded">Failed to load matchup data.</div>
            )}

            {!matchups.loading && !matchups.error && grouped.length === 0 && (
                <div className="p-2">No matchups found for week {week}.</div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                {grouped.map(({ key, a, b }) => {
                    const nameA = a ? (nameByRosterId.get(a.roster_id) || `Roster ${a.roster_id}`) : 'TBD';
                    const nameB = b ? (nameByRosterId.get(b.roster_id) || `Roster ${b.roster_id}`) : 'BYE';
                    const ptsA = a?.points != null ? Number(a.points).toFixed(2) : '-';
                    const ptsB = b?.points != null ? Number(b.points).toFixed(2) : '-';
                    const winA = (a?.points || 0) > (b?.points || 0);
                    const winB = (b?.points || 0) > (a?.points || 0);
                    return (
                        <div key={key} className="border rounded p-3  shadow-sm">
                            <div className="text-sm mb-2">Matchup {String(a?.matchup_id ?? key)}</div>
                            <div className="flex items-center justify-between mb-1">
                                <div className={`font-medium ${winA ? 'text-green-700' : ''}`}>{nameA}</div>
                                <div className={`tabular-nums ${winA ? 'font-bold' : ''}`}>{ptsA}</div>
                            </div>
                            <div className="flex items-center justify-between">
                                <div className={`font-medium ${winB ? 'text-green-700' : ''}`}>{nameB}</div>
                                <div className={`tabular-nums ${winB ? 'font-bold' : ''}`}>{ptsB}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
} */


function LeagueAvg(props) {

    const [year, setYear] = React.useState('2025');
    const years = ['2025','2024','2023','2022','2021','2020'];

    const urlAvg = `https://supermegadynasty.com/smd/reports/league_avg/${year}.json`
    const urlRank = `https://supermegadynasty.com/smd/reports/league_avg/${year}.json`
    console.log(urlAvg)
    const headCells = [
      {
        id: 'username',
        numeric: false,
        disablePadding: false,
        label: 'Team',
      },
      { id: 'qb_avg',   numeric: true, disablePadding: false, label: 'QB' },
      { id: 'rb1_avg',  numeric: true, disablePadding: false, label: 'RB1' },
      { id: 'rb2_avg',  numeric: true, disablePadding: false, label: 'RB2' },
      { id: 'wr1_avg',  numeric: true, disablePadding: false, label: 'WR1' },
      { id: 'wr2_avg',  numeric: true, disablePadding: false, label: 'WR2' },
      { id: 'te_avg',   numeric: true, disablePadding: false, label: 'TE' },
      { id: 'wrt1_avg', numeric: true, disablePadding: false, label: 'WRT1' },
      { id: 'wrt2_avg', numeric: true, disablePadding: false, label: 'WRT2' },
      { id: 'wrtq_avg', numeric: true, disablePadding: false, label: 'WRTQ' },
      { id: 'total_score', numeric: true, disablePadding: false, label: 'Avg Score' },
    ];

    const heatMapCells1 = [
        {
            id: 'username',
            numeric: false,
            disablePadding: false,
            label: 'Team',
        },
        {
          id: 'qb_avg',
          numeric: true,
          disablePadding: false,
          label: 'QB',
        },
        {
          id: 'rb1_avg',
          numeric: true,
          disablePadding: false,
          label: 'RB1',
        },
        {
          id: 'rb2_avg',
          numeric: true,
          disablePadding: false,
          label: 'RB2',
        },
        {
          id: 'wr1_avg',
          numeric: true,
          disablePadding: false,
          label: 'WR1',
        },
        {
          id: 'wr2_avg',
          numeric: true,
          disablePadding: false,
          label: 'WR2',
        },
        {
          id: 'te_avg',
          numeric: true,
          disablePadding: false,
          label: 'TE',
        },
        {
          id: 'wrt1_avg',
          numeric: true,
          disablePadding: false,
          label: 'WRT1',
        },
        {
          id: 'wrt2_avg',
          numeric: true,
          disablePadding: false,
          label: 'WRT2',
        },
        {
            id: 'wrtq_avg',
            numeric: true,
            disablePadding: false,
            label: 'WRTQ',
        },
    ];

    const headCells2 = [
        {
            id: 'username',
            numeric: false,
            disablePadding: false,
            label: 'Team',
        },
        {
            id: 'qb_rank',
            numeric: true,
            disablePadding: false,
            label: 'QB',
        },
        {
            id: 'rb_rank',
            numeric: true,
            disablePadding: false,
            label: 'RBs',
        },
        {
            id: 'wr_rank',
            numeric: true,
            disablePadding: false,
            label: 'WRs',
        },
        {
            id: 'te_rank',
            numeric: true,
            disablePadding: false,
            label: 'TE',
        },
        {
            id: 'wrt_rank',
            numeric: true,
            disablePadding: false,
            label: 'WRTs',
        },
        {
            id: 'wrtq_rank',
            numeric: true,
            disablePadding: false,
            label: 'WRTQ',
        },
        {
            id: 'total_score_rank',
            numeric: true,
            disablePadding: false,
            label: 'Scoring',
        }
    ];

    const heatMapCells2 = [
        {
            id: 'qb_rank',
            numeric: true,
            disablePadding: false,
            label: 'QB',
        },
        {
            id: 'rb_rank',
            numeric: true,
            disablePadding: false,
            label: 'RBs',
        },
        {
            id: 'wr_rank',
            numeric: true,
            disablePadding: false,
            label: 'WRs',
        },
        {
            id: 'te_rank',
            numeric: true,
            disablePadding: false,
            label: 'TE',
        },
        {
            id: 'wrt_rank',
            numeric: true,
            disablePadding: false,
            label: 'WRTs',
        },
        {
            id: 'wrtq_rank',
            numeric: true,
            disablePadding: false,
            label: 'WRTQ',
        },
        {
            id: 'total_score_rank',
            numeric: true,
            disablePadding: false,
            label: 'Scoring',
        }
    ];

    console.log('LINEUP AVG. PAGE')

    // TEST HEATMAP
    const yLabels = new Array(12).fill(0).map((_, i) => `${i+1}`);
    const xLabels = ["QB", "RB", "WR", "TE", "WRT", "WRTQ"];

    const data = new Array(yLabels.length)
    .fill(0)
    .map(() =>
        new Array(xLabels.length).fill(0).map(() => Math.floor(Math.random() * 100))
    );

    // const title = `Team ${props.team} Roster for Year: ${props.year} Week: ${props.week}`
    const title = `Lineup Position Averages ${year}`

    return (
        <>
            <div className="mb-2">
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <FormControl size="small" sx={{ minWidth: 140 }}>
                        <InputLabel id="league-avg-year">Year</InputLabel>
                        <Select
                            labelId="league-avg-year"
                            id="league-avg-year"
                            value={year}
                            label="Year"
                            onChange={(e) => setYear(String(e.target.value))}
                        >
                            {years.map((y) => (
                                <MenuItem key={y} value={y}>{y}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </div>

            <div className="md:flex flex-wrap">
                <div className="basis-1/2 pr-2">
                    <div>
                    {/* <h2>Team {props.team} Roster for Year: {props.year} Week: {props.week}</h2> */}
                    </div >
                    {/* {product.data.player_map.map(item => <div>{item.full_name}</div>)} */}
                    <MuiTable table='league_avg' headCells={headCells} url={urlAvg} title={title} page={30}/>
                </div>
                <div className="basis-1/2 ">
                    <div>
                    {/* <h2>Team {props.team} Roster for Year: {props.year} Week: {props.week}</h2> */}
                    </div >
                    {/* {product.data.player_map.map(item => <div>{item.full_name}</div>)} */}
                    <MuiTable table='league_rank_avg' headCells={headCells2} url={urlRank} title={`Lineup Position Ranks ${year}`} page={30}/>
                </div>
            </div>
            <div className="md:flex flex-wrap mb-3">
                <div className="basis-1/2 pr-2 ">
                    {/* <  HeatMap xLabels={xLabels} yLabels={yLabels} data={data} cellRender={(value) => value && `${value}`} />, */}
                    <MuiTable type='league_avg' headCells={heatMapCells1} url={urlAvg} title="Lineup by Roster Position Scoring Avg"/>
                </div>
                {/* <div className="basis-1/2  ">
                    <  HeatMap xLabels={xLabels} yLabels={yLabels} data={data} cellRender={(value) => value && `${value}`} />,
                    <RankMap type='rank' headCells={heatMapCells2} url={url}/>
                </div> */}
            </div>
            {/* <div className="md:flex flex-wrap mb-3">
                <div className=" basis-1/2  ">
                    <  HeatMap xLabels={xLabels} yLabels={yLabels} data={data} cellRender={(value) => value && `${value}`} />,
                    <ApexHeatMap title="Heat Map of Scoring" type='avg' headCells={heatMapCells1} url={url}/>
                </div>
                <div className="basis-1/2  ">
                    <  HeatMap xLabels={xLabels} yLabels={yLabels} data={data} cellRender={(value) => value && `${value}`} />,
                    <ApexHeatMap title="Heat Map of Ranking" type='rank' headCells={heatMapCells2} url={url}/>
                </div>
            </div> */}
        </>
    );
}

function CompareTree() {
    // const league = useSelector((state) => state.league.value)
    // const league = selectLeague()
    // console.log(`league=${league}`)

    return (
        <>
            <div className="">
                <ResponsiveLeagueGrid />
            </div>
            <Divider />
        </>
    );
}

function ResponsiveLeagueGrid() {
    return (
        <>
            <div className="md:flex flex-wrap">
                <div className="p-2 basis-1/3 ">
                    <div>
                    {/* <h2>Team {props.team} Roster for Year: {props.year} Week: {props.week}</h2> */}
                    </div >
                    {/* {product.data.player_map.map(item => <div>{item.full_name}</div>)} */}
                    <Overview />
                </div>
                <div className="p-2 basis-1/3 ">
                    <div>
                    {/* <h2>Team {props.team} Roster for Year: {props.year} Week: {props.week}</h2> */}
                    </div >
                    {/* {product.data.player_map.map(item => <div>{item.full_name}</div>)} */}
                    <Overview />
                </div>
                <div className="p-2 basis-1/3 ">
                    <div>
                    {/* <h2>Team {props.team} Roster for Year: {props.year} Week: {props.week}</h2> */}
                    </div >
                    {/* {product.data.player_map.map(item => <div>{item.full_name}</div>)} */}
                    {/* <LineChart /> */}
                </div>
            </div>
            <div className="md:flex flex-wrap mb-3">
                <div className="p-3 basis-1/2  ">
                    {/* <  HeatMap xLabels={xLabels} yLabels={yLabels} data={data} cellRender={(value) => value && `${value}`} />, */}
                    {/* <BarChart /> */}
                </div>
                <div className="p-3 basis-1/2  ">
                    {/* <  HeatMap xLabels={xLabels} yLabels={yLabels} data={data} cellRender={(value) => value && `${value}`} />, */}
                    {/* <BarChart /> */}
                </div>
            </div>
        </>


        // <Box sx={{ flexGrow: 1, flexBasis: '50%' }}>
        //     <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 2, sm: 2, md: 4 }}>
        //         <Grid item xs={1} sm={1} md={2} key='tree1'>
        //             <Overview />
        //         </Grid>
        //         <Grid item xs={1} sm={1} md={2} key='tree2'>
        //             <Overview />
        //         </Grid>
        //         <Grid item xs={1} sm={1} md={2} key='bar1'>
        //             <BarChart />
        //         </Grid>
        //         <Grid item xs={1} sm={1} md={2} key='bar2'>
        //             <BarChart />
        //         </Grid>

        //     </Grid>
        // </Box>
    );
}

function Three() {
    return (
        <div className="p-3">
            <h2>Standings by Week</h2>
            <LineChart />
        </div>
    );
}

function Four() {
    return (
    <div className="p-3">
        <h2>44444</h2>
    </div>
    );
}

function Five() {
    return (
        <div className="p-3">
            <h2>55555</h2>
        </div>
    );
}
